window.addEventListener( 'DOMContentLoaded', () => {
    let splide = new Splide( '.splide.featured' , {
        type: 'loop',
        perMove: 1,
        pagination: false,
        arrows: true,
        perPage: 2,
        drag: true,
        gap: 16,
        speed: 800,
        breakpoints: {
            768: {
                perPage: 2.3
            },
            420: {
                perPage: 1.6
            }
        },
    });

    splide.mount();
});
